import axios from 'axios';

async function ObtenerLocalidad(prmIdLocalidad: number) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_localidad"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "id_localidad": prmIdLocalidad
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerLocalidad;